import { useLocation } from "react-router-dom";
import { Loading, LoadTable } from "../../../Components";
import HeaderDiv from "../../../Components/HeaderDiv/HeaderDiv";
import "./AccountCheck.scss";

const MonthlyAccountBalanceCheck = () => {
  const Key = "Monthly_Account_Check";
  const location = useLocation();
  const { previous, afterCheck } = location.state?.monthlyAccountBalanceData;

  return (
    <div>
      <HeaderDiv title="Monthly account balances data" MoreActions={{ Is_Add: false, Is_Edit: false, Is_Delete: false, Is_View: false, Is_Back: true }} />
      <div className="previous_afterCheck_Main_Container">
        <div>
          {!previous.length > 0 && !previous.length === 0 ? (
            <Loading />
          ) : previous.length === 0 ? (
            <p className="DataNotAvailable">Data not Available</p>
          ) : (
            <>
              <h5>Previous monthly account balance</h5>
              <LoadTable data={previous} loading={false} title={Key} settings={false} options={false}/>
            </>
          )}
        </div>
        <div>
          {!afterCheck.length > 0 && !afterCheck.length === 0 ? (
            <Loading />
          ) : afterCheck.length === 0 ? (
            <p className="DataNotAvailable">Data not Available</p>
          ) : (
            <>
              <h5>After check monthly account balance</h5>
              <LoadTable data={afterCheck} loading={false} title={Key} settings={false} options={false}/>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MonthlyAccountBalanceCheck;
